module.exports = __webpack_public_path__ + "img/1.42c62c62.png";